import { BrowserDatamatrixCodeReader } from '@zxing/browser'
import React, { useEffect, useRef, useState } from 'react'
import decode from './decoder'
import FlipCameraAndroidIcon from '@material-ui/icons/FlipCameraAndroid';
import CloseIcon from '@material-ui/icons/Close';

type MobileCameraProps = { onClose: () => void, onData: (d: Record<string, string>) => void }

const MobileCamera: React.FC<MobileCameraProps> = ({ onClose, onData }) => {
    const videoRef = useRef<HTMLVideoElement>(document.createElement('video'))
    const [facingMode, setFacingMode] = useState<'environment' | 'user'>('environment')
    const [canFlip, setCanFlip] = useState(false)
    const [canAccessCamera, setCanAccessCamera] = useState(false)

    useEffect(() => {
        let stream: MediaStream | undefined = undefined

        navigator.mediaDevices.getUserMedia({ video: { facingMode }, audio: false })
            .then(s => {
                setCanAccessCamera(true)
                stream = s
                new BrowserDatamatrixCodeReader().decodeOnceFromStream(s, videoRef.current)
                    .then((r) => onData(decode(r?.getText())))
            })
            .catch(e => console.log(e))

        return () => {
            stream?.getTracks().forEach(t => t.stop())
        }
    }, [onData, facingMode])

    useEffect(() => { navigator.mediaDevices.enumerateDevices().then(devices => setCanFlip(devices.filter(d => d.kind === 'videoinput').length > 1)) }, [])

    const flipCamera = () => setFacingMode(facingMode === 'environment' ? 'user' : 'environment')

    if (!canAccessCamera) return null

    return (
        <div style={{ position: 'absolute', top: 0, left: 0, height: '100vh', width: '100vw', margin: 0, zIndex: 3 }}>
            <div style={{ position: 'absolute', top: 0, left: 0, display: 'flex', height: '100vh', width: '100vw', justifyItems: 'center', alignItems: 'center', justifyContent: 'center', zIndex: 2 }}>
                <div style={{ border: 'green 3px solid', height: '6rem', width: '6rem' }}></div>
            </div>
            <div style={{ position: 'absolute', top: 0, left: 0, width: '100vw', background: '#fff', zIndex: 2 }}>
                {canFlip && <div onClick={flipCamera} style={{ float: 'left', padding: 15 }}><FlipCameraAndroidIcon style={{ fontSize: '2.75rem' }} /></div>}
                <div onClick={onClose} style={{ float: 'right', padding: 15 }}><CloseIcon style={{ fontSize: '2.75rem' }} /></div>
            </div>
            <div style={{ zIndex: 1 }}>
                <video ref={videoRef} style={{ width: '100vw', height: '100vh', objectFit: 'cover' }} />
            </div>
        </div>
    )
}

export default MobileCamera
